/* ============
 * Main File
 * ============
 */
import Vue from 'vue';

/* ============
 * Setup
 * ============
 */
import store from 'store';
import 'directives';
import router from '@/setup/router';
import { i18nLoadLanguage } from '@/setup/i18n';
import '@/setup/validate';
import '@/setup/components';

/* ============
 * Styling
 * ============
 */
import 'styles/main.scss';

/* ============
 * Main App
 * ============
 */
import App from './App';

// Verify if the vue-devtools mode is disabled or enabled
Vue.config.devtools =
  process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
Vue.config.productionTip = false;

// First load default or user defined language
i18nLoadLanguage().then(
  i18n =>
    new Vue({
      el: '#app',
      render: h => h(App),
      // The localization plugin.
      i18n,
      // The router.
      router,
      // The Vuex store.
      store
    })
);
